import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ReactFlowProvider } from "reactflow";
import Home from "./components/Home";
import Signup from "./components/Signup";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import MessagingPage from "./pages/MessagingPage";
import GenealogyTree from "./components/GenealogyTree";
import PhotoAlbum from "./components/PhotoAlbum";
import FamilyStories from "./components/FamilyStories";
import InviteMembers from "./components/InviteMembers";
import Profile from "./components/Profile";
import Cagnottes from "./components/Cagnottes"; 
import CalendarSection from "./components/CalendarSection"; 

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setCurrentUser(JSON.parse(userData));
    }
  }, []);

  return (
    <Router>
      <ReactFlowProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard currentUser={currentUser} />} />
          <Route path="/messaging" element={<MessagingPage />} />
          <Route path="/genealogy-tree" element={<GenealogyTree />} />
          <Route path="/photo-album" element={<PhotoAlbum />} />
          <Route path="/family-stories" element={<FamilyStories />} />
          <Route path="/invite-members" element={<InviteMembers />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/cagnottes" element={<Cagnottes />} />
  <Route path="/events" element={<CalendarSection />} />
</Routes>
      </ReactFlowProvider>
    </Router>
  );
}

export default App;